import React, {
  Fragment,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { MENUITEMS } from "./sideMenu";
import { NavLink } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { useLocation } from "react-router-dom";
let history = [];
const SideBar = () => {
  let location = useLocation();
  const [menuitems, setMenuitems] = useState(MENUITEMS);
  const scrollbarsRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const mainContentClickFn = useCallback(() => {
    if (
      document.body.classList.contains("horizontalmenu") &&
      window.innerWidth >= 992
    ) {
      clearMenuActive();
    }
  }, []);

  useEffect(() => {
    history.push(location.pathname);
    if (history.length > 2) {
      history.shift();
    }
    let mainContent = document.querySelector(".main-content");
    mainContent.addEventListener("click", mainContentClickFn);
    return () => {
      mainContent.removeEventListener("click", mainContentClickFn);
    };
  }, [location.pathname, mainContentClickFn]);

  useEffect(() => {
    if (
      document.body.classList.contains("horizontalmenu") &&
      window.innerWidth >= 992
    ) {
      clearMenuActive();
    }
  }, []);

  // Preserve scroll position when location changes
  useEffect(() => {
    if (scrollbarsRef.current) {
      // Restore scroll position after a short delay to ensure DOM is updated
      // setTimeout(() => {
      scrollbarsRef.current.scrollTop(scrollPosition);
      // }, 100);
    }
  }, [location.pathname, scrollPosition]);

  // Save scroll position before navigation
  const handleNavLinkClick = useCallback(() => {
    if (scrollbarsRef.current) {
      const currentScrollTop = scrollbarsRef.current.getScrollTop();
      setScrollPosition(currentScrollTop);
    }
  }, []);

  let menuIcontype;
  if (document.querySelector("body").classList.contains("horizontalmenu")) {
    menuIcontype = "hor-icon";
  } else {
    menuIcontype = "sidemenu-icon";
  }
  //  In Horizontal When we click the body it should we Closed
  // eslint-disable-next-line react-hooks/exhaustive-deps

  // Helper function to check if a menu item is active
  const isMenuItemActive = useCallback(
    (menuItem) => {
      const currentPath = location.pathname;
      const currentSearch = location.search;
      const currentType = new URLSearchParams(currentSearch).get("type");

      const itemPath = menuItem.path.split("?")[0];
      const itemSearch = menuItem.path.includes("?")
        ? menuItem.path.split("?")[1]
        : "";
      const itemType = itemSearch
        ? new URLSearchParams(itemSearch).get("type")
        : null;

      // Check if current path starts with the menu item path (for nested routes)
      const pathMatches = currentPath === itemPath || currentPath.includes(itemPath);
      const typeMatches = itemType === currentType;

      // For items without type parameter, only check path
      return itemType ? pathMatches && typeMatches : pathMatches;
    },
    [location.pathname, location.search]
  );

  function clearMenuActive() {
    MENUITEMS.filter((mainlevel) => {
      if (mainlevel.Items) {
        mainlevel.Items.filter((sublevel) => {
          sublevel.active = false;
          if (sublevel.children) {
            sublevel.children.filter((sublevel1) => {
              sublevel1.active = false;
              if (sublevel1.children) {
                sublevel1.children.filter((sublevel2) => {
                  sublevel2.active = false;
                  return sublevel2;
                });
              }
              return sublevel1;
            });
          }
          return sublevel;
        });
      }
      return mainlevel;
    });
    setMenuitems((arr) => [...arr]);
  }

  function Onhover() {
    if (document.querySelector(".main-body")) {
      if (
        document
          .querySelector(".main-body")
          .classList.contains("main-sidebar-hide")
      )
        document.querySelector(".main-body").classList.add("main-sidebar-open");
    }
  }
  function Outhover() {
    if (document.querySelector(".main-body")) {
      document
        .querySelector(".main-body")
        .classList.remove("main-sidebar-open");
    }
  }

  return (
    <Fragment>
      <div className="sticky " style={{ marginBottom: "-64px" }}>
        <div className="main-menu main-sidebar main-sidebar-sticky side-menu">
          <div className="main-container-1 active main-sidebar-header">
            <Scrollbars
              ref={scrollbarsRef}
              options={{ removeTrackXWhenNotUsed: true }}
              className="hor-scroll"
              style={{ position: "absolute" }}>
              {/* <div className="sidemenu-logo">
                <Link
                  className="main-logo"
                  to={`${process.env.REACT_APP_HOME_PAGE}dashboard/`}
                >
                  <img
                    src={require("../../../assets/img/brand/logo-light.png")} 
                     className="header-brand-img desktop-logo"
                    alt={"logo1"}
                  />

                  <img
                    src={require("../../../assets/img/brand/icon-light.png")}
                    className="header-brand-img icon-logo"
                    alt={"logo-2"}
                  />
                </Link>
              </div> */}
              <div
                className="main-body-1 main-sidebar-body"
                onMouseOver={() => Onhover()}
                onMouseOut={() => Outhover()}>
                <ul
                  className="menu-nav nav"
                  style={{ marginLeft: "0px", display: "block" }}>
                  {menuitems.map((Item, itemi) => (
                    <Fragment key={itemi + Math.random() * 100}>
                      <li className="nav-header">
                        <span className="nav-label">{Item.menutitle}</span>
                      </li>
                      {Item.Items.map((menuItem, i) => (
                        <li
                          className={`nav-item ${
                            isMenuItemActive(menuItem) ? "active" : ""
                          }`}
                          key={i}>
                          {menuItem.type === "link" ? (
                            <NavLink
                              to={menuItem.path}
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              isActive={() => isMenuItemActive(menuItem)}
                              onClick={handleNavLinkClick}>
                              <span className="shape1"></span>
                              <span className="shape2"></span>
                              <i
                                className={`${menuItem.icon} ${menuIcontype} menu-icon`}></i>
                              <span className="sidemenu-label">
                                {menuItem.title}
                              </span>
                              {menuItem.badge ? (
                                <label className={menuItem.badge}>
                                  {menuItem.badgetxt}
                                </label>
                              ) : (
                                ""
                              )}
                            </NavLink>
                          ) : (
                            ""
                          )}
                        </li>
                      ))}
                    </Fragment>
                  ))}
                </ul>
                <div className="slide-right" id="slide-right">
                  <i className="fe fe-chevron-right"></i>
                </div>
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
      <div className="jumps-prevent" style={{ paddingTop: "64px" }}></div>
    </Fragment>
  );
};

export default SideBar;
